import { Grid } from "@mui/material";
import { FORM_ERROR } from "final-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./Login.module.css";
import { googleLogin, userDetail } from "../../../../store/auth";
import { GoogleLogin } from '@react-oauth/google';

function Login() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const responseGoogle = (response) => {
		const { credential } = response;
		console.log(response)
		return dispatch(
			googleLogin({ token: credential })
		).then((resp) => {
			console.log("Google response :", resp)
			if (resp.payload && resp.payload.status !== "OK") {
				return { [FORM_ERROR]: resp.payload.message };
			} else {
				dispatch(userDetail()).then(() => {
					navigate("/landing");
				});
			}
		});
	};

	return (
		<Grid container direction="column" justifyContent="center" alignItems="center" style={{ minHeight: "100vh" }}>
			<Grid item xs={7} style={{ width: "100%" }}>
				<Grid container spacing={9} alignItems="center" justifyContent="center">
					<Grid item xs={1} className={styles.PageLogo} alignItems="center" justify="flex-end"></Grid>
					<Grid alignItems="center" justify="flex-end" >
						<GoogleLogin
							onSuccess={responseGoogle}
							onError={() => {
								console.log('Login Failed');
							}}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

export default Login;
